/***************************************************
 * Created by gongyanyu on 2022/10/27 10:43. *
 ***************************************************/
import { TreeRecord } from '../interfaces/types';

/**
 * 将树形结构数据扁平化
 * @param data 树形结构数据
 * @returns 扁平化后的数据
 */
export function flat(data: TreeRecord[]): TreeRecord[] {
  const oo: TreeRecord[] = [];

  function each(data: TreeRecord[]) {
    if (!data) return;
    let i = -1;
    while (++i < data.length) {
      oo.push(data[i]);
      if (Array.isArray(data[i].children)) {
        each(data[i].children);
      }
    }
  }

  each(data);
  return oo;
}
